import axios from "axios";
import type { PackagesResponse } from "./types";

const isLocal = window.location.origin.includes("localhost");
const API_BASE = isLocal
  ? "/api"
  : "https://api.centralcart.com.br/v1/webstore";


export const getPackages = async (): Promise<PackagesResponse | null> => {
  try {
    const response = await axios.get<PackagesResponse>(
      `${API_BASE}/package?all=true&v=2&limit=9999`,
      {
        headers: {
          "x-store-domain": "howstore.gg",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error: unknown) {
    return null;
  }
};
